import { Route } from "react-router-dom";
import PrivacyPolicyPage from "@/pages/legal/privacy/index";
import CookiePolicyPage from "@/pages/legal/cookies/index";
import TermsOfServicePage from "@/pages/legal/terms/index";
import CommunityGuidelinesPage from "@/pages/legal/community-guidelines/index";
import PrivacyPolicyVietnamesePage from "@/pages/vi/privacy/index";
import CookiePolicyVietnamesePage from "@/pages/vi/cookies/index";
import TermsOfServiceVietnamesePage from "@/pages/vi/terms/index";
import CommunityGuidelinesVietnamesePage from "@/pages/vi/community-guidelines/index";
import UniversalLinkPage from "@/pages/universal-link";

export const legalRoutes = [
  // English Legal Pages - Multiple URL patterns for compatibility
  <Route
    key="legal-privacy"
    path="/legal/privacy"
    element={<PrivacyPolicyPage />}
  />,
  <Route
    key="legal-cookies"
    path="/legal/cookies"
    element={<CookiePolicyPage />}
  />,
  <Route
    key="legal-terms"
    path="/legal/terms"
    element={<TermsOfServicePage />}
  />,
  <Route
    key="legal-community-guidelines"
    path="/legal/community-guidelines"
    element={<CommunityGuidelinesPage />}
  />,

  // Alternative URL patterns that user might expect
  <Route
    key="pages-en-privacy"
    path="/pages/en/privacy"
    element={<PrivacyPolicyPage />}
  />,
  <Route
    key="pages-en-cookies"
    path="/pages/en/cookies"
    element={<CookiePolicyPage />}
  />,
  <Route
    key="pages-en-terms"
    path="/pages/en/terms"
    element={<TermsOfServicePage />}
  />,
  <Route
    key="pages-en-community-guidelines"
    path="/en/community-guidelines"
    element={<CommunityGuidelinesPage />}
  />,

  // Vietnamese Legal Pages - Multiple URL patterns
  <Route
    key="vi-privacy"
    path="/vi/privacy"
    element={<PrivacyPolicyVietnamesePage />}
  />,
  <Route
    key="vi-cookies"
    path="/vi/cookies"
    element={<CookiePolicyVietnamesePage />}
  />,
  <Route
    key="vi-terms"
    path="/vi/terms"
    element={<TermsOfServiceVietnamesePage />}
  />,
  <Route
    key="vi-community-guidelines"
    path="/vi/community-guidelines"
    element={<CommunityGuidelinesVietnamesePage />}
  />,

  // Alternative Vietnamese URL patterns
  <Route
    key="pages-vi-privacy"
    path="/pages/vi/privacy"
    element={<PrivacyPolicyVietnamesePage />}
  />,
  <Route
    key="pages-vi-cookies"
    path="/pages/vi/cookies"
    element={<CookiePolicyVietnamesePage />}
  />,
  <Route
    key="pages-vi-terms"
    path="/pages/vi/terms"
    element={<TermsOfServiceVietnamesePage />}
  />,
  <Route
    key="pages-vi-community-guidelines"
    path="/pages/vi/community-guidelines"
    element={<CommunityGuidelinesVietnamesePage />}
  />,

  // Legacy URL patterns for backward compatibility
  <Route
    key="privacy-policy"
    path="/privacy-policy"
    element={<PrivacyPolicyPage />}
  />,
  <Route
    key="cookie-policy"
    path="/cookie-policy"
    element={<CookiePolicyPage />}
  />,
  <Route
    key="terms-of-service"
    path="/terms-of-service"
    element={<TermsOfServicePage />}
  />,
  <Route
    key="community-guidelines"
    path="/community-guidelines"
    element={<CommunityGuidelinesPage />}
  />,
  <Route key="terms" path="/terms" element={<TermsOfServicePage />} />,
  <Route key="privacy" path="/privacy" element={<PrivacyPolicyPage />} />,

  // Universal Link Route - Public access for app deep linking
  <Route
    key="universal-link"
    path="/app-links/*"
    element={<UniversalLinkPage />}
  />,
];
